import { TCompanyState } from '@/redux/reducers/company';
import { TCreateBillingPortalSessionSuccess } from '@/redux/actions/company';

export const createBillingPortalSessionUpdateState = (
  state: TCompanyState,
  action: TCreateBillingPortalSessionSuccess,
): TCompanyState => {
  const updatedState = {
    ...state,
    billingPortalResponse: action.payload.response,
  };
  return updatedState;
};
